import { Broker, PromiseResolver } from '@acs-manageability/core'

import SignalClient from './SignalClient'
import Connection from './Connection'
import ResourceAllocation from './ResourceAllocation'
import TurnAuthentication from './TurnAuthentication'
export * from './FullscreenUtils'

export const promiseResolver = new PromiseResolver()
export const broker = new Broker()

export const signalClient = SignalClient(broker)

export const connectionClient = Connection({
  webSocketConnection: signalClient,
  promiseResolver,
  broker,
})

export const resourceAllocationClient = ResourceAllocation({
  webSocketConnection: signalClient,
  broker,
  promiseResolver,
})

export const turnAuthenticationClient = new TurnAuthentication(
  signalClient,
  broker,
  promiseResolver,
)
